/**
 * Flattens editor HTML *and* raw LaTeX delimiters to one readable line.
 *
 * For list rows, tooltips and dropdown labels — places too small to typeset
 * math, where `RenderedHtml` doesn't fit but `\(a_{10} + a_{12} = 25\)` still
 * shouldn't leak through as backslashes and parens.
 */
export function toPlainText(html: string | null | undefined): string {
  if (!html) return '';
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    // Math delimiters only — the expression itself stays, since `a_{10} + 25`
    // reads far better in a truncated row than nothing at all.
    .replace(/\\{1,2}[[\]()]|\$\$/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** The editor always emits at least an empty paragraph, so `!html.trim()` is wrong for editor-backed fields. */
export function htmlIsEmpty(html: string | null | undefined): boolean {
  if (!html) return true;
  if (/<(img|video|audio)\b/i.test(html)) return false;
  if (/<span\s+class=["']math-tex/i.test(html)) return false;
  const text = html
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return text.length === 0;
}
